import { IControlField2, IFieldResponse } from './control-field.base';

export interface INumberControlField extends IControlField2 {
  default_value?: number;
}

export function toNumberField(field: IFieldResponse): INumberControlField {
  let defaultValue = field.default_value;
  if (typeof defaultValue === 'string' && defaultValue) {
    defaultValue = Number(defaultValue);
  }
  return {
    id: field.id,
    alias: field.alias,
    control_type: field.control_type,
    default_value: defaultValue as number,
    helper_text: field.helper_text,
    is_visible: field.is_visible,
    is_active: field.is_active,
    is_disabled: field.is_disabled,
    is_mandatory: field.is_mandatory,
    name: field.name,
    placement_order: field.placement_order,
    section: field.section || '',
    dtype: field.dtype,
    prefix_label: field.prefix_label,
    suffix_label: field.suffix_label,
    is_auto_fill: field.is_auto_fill,
    planner_flag: field.planner_flag,
    info_details: field.info_details,
    is_info_enable: field.is_info_enable
  };
}
